import { render, staticRenderFns } from "./ProductoSelectComponent.vue?vue&type=template&id=c59bd224&"
import script from "./ProductoSelectComponent.vue?vue&type=script&lang=js&"
export * from "./ProductoSelectComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports